import { Elements } from '@stripe/react-stripe-js';
import SetupIntentModal from './SetupIntentModal';
import React from 'react';
import { useStripeSetupIntent } from '../../hooks/useStripeSetupIntent';
import { stripePromise } from '../../stripe';

export default function StripePaymentPortal({
  onCloseComplete,
  message,
}: {
  onCloseComplete: () => void;
  message?: string;
}) {
  const setupIntent = useStripeSetupIntent();
  if (!setupIntent.clientSecret) return <></>;

  return (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret: setupIntent.clientSecret,
        customerSessionClientSecret: setupIntent.sessionClientSecret,
      }}
    >
      <SetupIntentModal
        onClose={() => {
          onCloseComplete();
          setupIntent.reset();
        }}
        message={message}
        email={setupIntent.email ?? undefined}
        phone={setupIntent.phone ?? undefined}
      />
    </Elements>
  );
}
